import './box2.css';

function contentbox(){
    return (
        <div className='cb2w'>
            <div className='cb2'>Work in Progress</div>
            <div className='cb2a'>Made in React</div>
        </div>
    );
}
export default contentbox;